<template>
  <div class="hrn-form">
    <el-form
      class="login-form form-custom clearfix"
      :class="{ 'mgb-more': fromGuest }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <!-- 手机号码 -->
      <el-form-item class="form-item-primary" prop="phone">
        <BaseInput
          v-if="hasBanner || isMergeLoginAndRegister"
          v-model="form.phone"
          :disabled="fromPlatform"
          :tabIndexNum="'3'"
          :validate-event="Boolean(form.phone)"
          placeholer="请输入手机号"
          :maxLength="11"
          @input="handlePhoneChange"
        >
          <template #prepend>
            <el-select
              :disabled="true"
              v-model="form.pretel"
              style="width: 100px"
            >
              <el-option
                v-for="item in preTelList"
                :value="item"
                :label="'+' + item"
                :key="'+' + item.toString()"
              >
                + {{ item }}
              </el-option>
            </el-select>
          </template>
        </BaseInput>
        <div v-else class="input-custom-disabled">
          +{{ form.pretel }}&nbsp;&nbsp;{{ form.phone | phoneFormat }}
        </div>
      </el-form-item>

      <!-- 验证码 -->
      <el-form-item class="form-item-primary" prop="verification_code">
        <BaseInput
          v-model.trim="form.verification_code"
          :maxlength="6"
          :validate-event="Boolean(form.verification_code)"
          placeholer="请输入验证码"
          :tabIndexNum="'4'"
          @focus="changeCode"
          @input="handleCodeChange"
        >
          <template #btn>
            <VerificationCode
              ref="verification"
              @click="sendCode"
              :account="form.phone"
              :from="'register'"
              :isActive="activeSms"
              class="hrn-verification"
            />
          </template>
          <template #prefix> 请输入验证码 </template>
        </BaseInput>
      </el-form-item>
    </el-form>

    <el-button
      class="button-custom"
      tabindex="6"
      @click="submit"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.${fromEvent ? 'enterEvent' : 'registerUser'}`,
      }"
      >{{ detailSubmitText }}</el-button
    >
    <!-- 协议及订阅 -->
    <template v-if="hasAgreement">
      <Agreement
        v-model="form.agreement"
        class="aggrement-unset aiahrn-aggrement"
      />
    </template>
    <!-- <div class="user-custom-tips" v-if="isMergeLoginAndRegister">
      <p>{{ customContent.Owndesc }}</p>
    </div> -->
    <!-- <login-footer :footerTitle="'虚拟空间技术支持: '" class="aia-hrn-footer" /> -->
  </div>
</template>

<script>
import VerificationCode from '@/components/login/VerificationCode.vue'
import BaseMixin from '@/mixins/BaseMixin'
import { checkPhone, checkSMSCode } from '@/utils/validate-rules'
import { getBusinessType } from '@/constant'
import store from '@/store'
import { handleSaveAndJumpWithMemberCard } from '@/utils/saveLogin.js'
import _throttle from 'lodash/throttle'
import { getItem } from '@/utils/storage-main'
import { handleBusinessRegiser } from '@/utils/mutiple.js'
import { gotinTrack } from '@frontend/gotin-track'
import { isNeedHandleSMSActive } from '@/utils/consts'
import { setExtraParams } from '@/utils/utils'
import tipsIcon from '@/assets/images/login/tips.svg'
import Agreement from '@/components/login/Agreement'

export default {
  name: '',
  props: {},
  mixins: [BaseMixin],
  data() {
    return {
      form: {
        phone: '',
      },
      isWrong: false,
      registeredPhone: '',
      tipsIcon: tipsIcon,
    }
  },

  components: { VerificationCode, Agreement },

  computed: {
    smsLength() {
      return store.state.smsLength
    },
    activeSms() {
      return store.state.activeSms
    },
    passAccount() {
      return checkPhone(this.currentAccount)
    },
    isMergeLoginAndRegister() {
      return getBusinessType().isMergeLoginAndRegister
    },
    customContent() {
      return getBusinessType()
    },
    hasAgreement() {
      return !this.fromGuest
    },
    detailSubmitText() {
      return '进入易空间'
    },
    rules() {
      return {
        phone: [
          {
            required: true,
            message: this.$t('login.register.labelRegisteredPhone'),
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              // 已知已注册号码不再提交请求进行多次校验
              this.hasChangePhone()
              if (this.registeredPhone)
                return callback(new Error(this.$t('login.register.exists')))

              if (checkPhone(value)) {
                // 检测是否注册
                if (!getBusinessType().isMergeLoginAndRegister) {
                  await this.handleCheckUserValidator(value, callback)
                } else {
                  callback()
                }
              } else {
                return callback(
                  new Error(this.$t('login.resetPassword.validPhone'))
                )
              }
              return callback(
                new Error(this.$t('login.resetPassword.validPhone'))
              )
            },
            trigger: 'blur',
          },
        ],
        verification_code: [
          {
            required: true,
            message: this.$t('login.register.labelCode'),
          },
          {
            validator: (rule, value, callback) => {
              if (this.isWrong) {
                callback(
                  new Error(this.$t('login.loginPage.wrongSecurityCode'))
                )
              } else {
                callback()
              }
            },
          },
        ],
      }
    },
  },

  created() {
    this._initData()
  },
  mounted() {
    const footerDom = document.querySelector('.aia-hrn-footer')
    document.body.appendChild(footerDom)
  },
  methods: {
    _initData() {
      setExtraParams()
    },
    // 验证码输入监听
    handleCodeChange: _throttle(function (val) {
      if (checkSMSCode(val)) {
        gotinTrack.standaloneSendData({
          name: `form.code_checked`,
          params: { value: val },
        })
      }
    }, 500),
    // 手机号输入监听
    handlePhoneChange: _throttle(function (val) {
      if (isNeedHandleSMSActive()) {
        const isValid = checkPhone(val)

        this.$store.commit('SET_SMSISACTIVE', isValid)

        if (isValid) {
          gotinTrack.standaloneSendData({
            name: `form.phone_checked`,
            params: { value: val },
          })
        }
      }
    }, 500),
    // 修改电话号码
    hasChangePhone() {
      if (this.form.phone !== this.registeredPhone) this.registeredPhone = ''
    },
    changeCode() {
      this.isWrong = false
    },
    sendCode() {
      if (this.registeredPhone) {
        return
      }
      this.$refs['form'].validateField('phone', (vaild) => {
        if (!vaild) {
          if (isNeedHandleSMSActive()) {
            this.$store.commit('SET_SMSISACTIVE', false)
          }
          this.$refs['verification'].send()
        }
      })
    },
    creatParams() {
      const { phone, verification_code } = this.form

      return { phone, verification_code }
    },
    async handleCheckUserValidator(value, callback) {
      try {
        let data = await store.dispatch('CheckUser', {
          user_name: value,
        })
        if (data.data === true) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.registered = false
          return callback()
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.registered = true
          return callback(new Error(this.$t('login.register.exists')))
        }
      } catch (error) {
        return callback()
      }
    },

    async fetchRegisterData(params) {
      return await store.dispatch('RegisterByPhone', params)
    },
    // 提交注册/加入活动/下一步
    submit: _throttle(
      async function () {
        if (!this.hasConfirmArgeement()) {
          return false
        }
        this.$refs['form'].validate(async (valid) => {
          try {
            if (valid) {
              // await api.user.postInMemberCard({ act: 'card', source: 'aiahrn' })
              let successData
              // 获取参数
              let params = this.creatParams()
              if (getBusinessType().isNeedTagedSource) {
                params.source = getBusinessType().unionId
              }
              // 分享功能与具体业务方无关，存在相应的字段传递就可以
              if (getBusinessType().isMergeLoginAndRegister) {
                const { phone, verification_code } = this.form
                let { data } = await store.dispatch('CheckUser', {
                  user_name: this.form.phone,
                })

                if (data) {
                  this.isLogin = false
                  // 未注册
                  let registerParams = {
                    firstName: '',
                    lastName: '',
                    password: '',
                    source: getBusinessType().unionId,
                    phone,
                    verification_code,
                  }
                  successData = await handleBusinessRegiser(
                    getItem('business'),
                    registerParams,
                    this.fetchRegisterData
                  )
                } else {
                  this.isLogin = true
                  let loginParams = {
                    user_name: phone,
                    verification_code,
                    source: getBusinessType().unionId,
                  }
                  successData = await store.dispatch(
                    'userSmsLogin',
                    loginParams
                  )
                }
              } else {
                successData = await handleBusinessRegiser(
                  getItem('business'),
                  params,
                  this.fetchRegisterData
                )
              }
              if (successData.code === 0) {
                await handleSaveAndJumpWithMemberCard(successData.data)
                this.isLogin
                  ? this.$message.success(this.$t('login.loginPage.success'))
                  : this.$message.success(this.$t('login.register.success'))
              }
            }
          } catch (error) {
            console.log(error, 'error tips', error.code)
            if (error.code === 11010) {
              this.isWrong = true
              this.$refs['form'].validateField('verification_code')
            }
          }
        })
      },
      500,
      { trailing: false }
    ),
    hasConfirmArgeement() {
      if (this.hasAgreement && !this.form.agreement) {
        this.$message.error({
          message: this.$t('login.register.acceptTermsPop'),
          customClass: 'nissan-error-message',
        })
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss">
.hrn-form {
  .hrn-verification {
    background: linear-gradient(180deg, #e4708f -14.96%, #d31145 100%);
    color: #ffffff;
  }
}

.login-footer.footer-aiahrn-wrap {
  display: none;
}

.aiahrn-layout {
  .is-mobile.aiahrn-container {
    padding-top: 100px !important;
  }

  .info-wrap.aiahrn-wrap {
    padding: 14px !important;
    padding-bottom: 10px !important;
    position: relative;
    z-index: 1;
    margin-top: 40px;
  }
}

.login-footer.aia-hrn-footer {
  width: 100%;
  height: 50px;
  position: fixed;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;
  color: #000000cc !important;
  display: block !important;
}

.is-pc {
  .aiahrn-container {
    padding-top: 0 !important;
    left: auto;
    right: 140px;
    background-color: #fff;

    .aiahrn-aggrement {
      margin-bottom: 30px;
    }

    .el-input__inner {
      background: #f9f9f9 !important;
    }
  }

  .box-title {
    color: #3d4d68 !important;
  }
}

.is-mobile {
  .box-info {
    display: none;
  }
}

.aiahrn-container {
  padding: 0 28px !important;
  padding-top: 150px !important;

  .el-input__inner,
  .input-custom {
    &:focus,
    &:hover,
    &:active,
    &.is-focus {
      border-color: #d72655 !important;
    }
  }

  .button-custom {
    border-radius: 8px;
    font-size: 16px;
    color: #fff !important;
    height: 56px;
    background: linear-gradient(180deg, #e4708f -14.96%, #d31145 100%);
  }

  .form-custom {
    margin-top: 24px;
  }

  .form-item-primary {
    margin-bottom: 25px !important;
  }

  .checkbox-custom {
    margin-right: 5px;
  }

  .logo-aiahrn {
    width: 205px;
    margin-bottom: 36px;
  }

  .user-custom-tips {
    color: #666 !important;
  }
}
</style>
